import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as occupants from '../../occupants'
import type * as responsiblePersons from '../../responsible-persons'
import type { TypeParams } from '../types'

/**
 * Clears all employee list filters when an occupant add session or a
 * responsible person creation session is completed or discarded.
 */
export const clearFiltersOnClose = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    recordOccupantsEc: occupants.recordOccupants.Collection,
    clusterOccupantsEc: occupants.clusterOccupants.Collection,
    recordResponsiblePersonsEc: responsiblePersons.recordResponsiblePersons.Collection,
    clusterResponsiblePersonsEc: responsiblePersons.clusterResponsiblePersons.Collection,
  ) =>
    rxjs
      .merge(
        recordOccupantsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
        clusterOccupantsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
        recordResponsiblePersonsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
        clusterResponsiblePersonsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
        recordOccupantsEc.plugins.editingPlugin.feature.actions.discard.request.observe(),
        clusterOccupantsEc.plugins.editingPlugin.feature.actions.discard.request.observe(),
        recordResponsiblePersonsEc.plugins.editingPlugin.feature.actions.discard.request.observe(),
        clusterResponsiblePersonsEc.plugins.editingPlugin.feature.actions.discard.request.observe(),
      )
      .pipe(
        rxjs.map(() =>
          collection.plugins.currentListPlugin.appliedParams.actions.writeAllProperties
            .from('clearFiltersOnClose (effect)')
            .create({
              values: {},
            }),
        ),
      ),
)
